import React from "react";
import { BreadcrumbContainer, BreadcrumbItem, InactiveBreadcrumbItem } from "./styles";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";

function BaseBreadcrumbs({ breadcrumbs }) {
  if (!breadcrumbs) return null;

  return (
    <>
      <BreadcrumbContainer
        separator={<ChevronRightIcon />}
        aria-label="breadcrumb"
      >
        {breadcrumbs.map(({ name, path, active }) => (
          path ? (
            <BreadcrumbItem key={name} active={active} to={path}>
              {name}
            </BreadcrumbItem>
          ) : (
            <InactiveBreadcrumbItem key={name} active={active}>
              {name}
            </InactiveBreadcrumbItem>
          )
        ))}
      </BreadcrumbContainer>
    </>
  );
}

export default BaseBreadcrumbs;
